<template>
  <div class="loginWrapper">
    <Login/> 
  </div>
</template>
<script>
import Login from '@/components/login/login'
export default {
  name: "login",
  components: { Login },
  data() {
    return {
      activeName: "sms"
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
  }
};
</script>
<style scoped lang="scss">
.loginWrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-image: url("https://static.zc0901.com/dci-miniapp/login.png");
  background-size: cover;
  position: relative;
  min-height:500px;
  
}
</style>
<style lang="scss">
</style>
